module.exports = __webpack_public_path__ + "img/report_black_justice_may_1931-cropped.ffb67c54.jpg";